"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromptChip = exports.PROMPT_CHIP_TYPE = void 0;
var React = _interopRequireWildcard(require("react"));
var _typography = require("../../types/typography");
var _classify = require("../../utils/classify");
var _ConditionalWrapper = require("../ConditionalWrapper");
var _Icon = require("../Icon");
var _Tooltip = require("../Tooltip");
var _PromptChipModule = _interopRequireDefault(require("./PromptChip.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const PROMPT_CHIP_TYPE = Object.freeze({
  primary: 'primary',
  secondary: 'secondary'
});
exports.PROMPT_CHIP_TYPE = PROMPT_CHIP_TYPE;
const PromptChip = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    type = PROMPT_CHIP_TYPE.primary,
    onClick,
    iconType = _Icon.ICON_TYPE.solid,
    iconName = 'lightbulb',
    children,
    iconColor,
    rightSlot,
    onDismiss,
    classNames,
    dismissable,
    selfDismiss,
    showInfoIcon,
    infoIconTooltip
  } = props;
  const [dismissed, setDismissed] = React.useState(false);
  const closeClickHandler = e => {
    e.stopPropagation();
    onDismiss?.(e);
    selfDismiss && setDismissed(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !dismissed && /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-testid": "Prompt-Chip",
    className: (0, _classify.classify)(_PromptChipModule.default.promptChipWrapper, {
      [_PromptChipModule.default.primary]: type === PROMPT_CHIP_TYPE.primary,
      [_PromptChipModule.default.secondary]: type === PROMPT_CHIP_TYPE.secondary
    }, classNames?.wrapper),
    onClick: event => {
      onClick?.(event);
    },
    tabIndex: onClick ? 0 : undefined,
    role: "button"
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_PromptChipModule.default.promptChipContainer, {
      [_PromptChipModule.default.promptChipContainerHover]: !!onClick
    }, classNames?.container)
  }, /*#__PURE__*/React.createElement("div", {
    className: _PromptChipModule.default.leftSection
  }, /*#__PURE__*/React.createElement(_Icon.Icon, {
    size: _Icon.ICON_SIZE.small,
    name: iconName,
    type: iconType,
    color: iconColor,
    className: (0, _classify.classify)({
      [_PromptChipModule.default.chipIconDefaultColor]: !iconColor
    }, classNames?.icon)
  }), !!children && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_PromptChipModule.default.childrenWrapper, classNames?.children)
  }, children)), /*#__PURE__*/React.createElement("div", {
    className: _PromptChipModule.default.rightSection
  }, rightSlot ? rightSlot : null, !!showInfoIcon && /*#__PURE__*/React.createElement(_ConditionalWrapper.ConditionalWrapper, {
    condition: infoIconTooltip && typeof infoIconTooltip === 'object' && Object.keys(infoIconTooltip).length > 0,
    wrapper: children => /*#__PURE__*/React.createElement(_Tooltip.Tooltip, infoIconTooltip, children)
  }, /*#__PURE__*/React.createElement(_Icon.Icon, {
    size: _Icon.ICON_SIZE.small,
    name: "info-circle",
    color: _typography.TEXT_COLORS.primary,
    className: classNames?.icon
  })), !!dismissable && /*#__PURE__*/React.createElement(_Icon.CloseIcon, {
    size: _Icon.ICON_SIZE.small,
    onClick: closeClickHandler,
    ariaLabel: "Dismiss",
    className: _PromptChipModule.default.dismissIcon
  })))));
});
exports.PromptChip = PromptChip;